import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Language } from '../interfaces/language';
import { EmittersService } from '../utils/emitters.service';
import { StorageService } from '../utils/storage.service';
import { AuthenticationService } from './authentication.service';
import { servicesConfig } from './services.config';

const BASE_URL = servicesConfig.api.url + servicesConfig.languageHandling.mainEndpoint;

@Injectable({
	providedIn: 'root'
})
export class LanguageService {
	private _http = inject(HttpClient);
	private _authService = inject(AuthenticationService);
	private _translate = inject(TranslateService);
	private _emittersService = inject(EmittersService);
	private _storageService = inject(StorageService);

	first = false;
	private loadedUserId = '';
	private loadingUserId = '';

	setLanguage(): void {
		const userId = this._authService.currentUser?.user?.sub;
		if (!userId || this.loadedUserId === userId || this.loadingUserId === userId) return;
		const dropdownLanguage = this._storageService.getDataStorage('dropdown-language');
		if (dropdownLanguage) {
			this.loadedUserId = userId;
			this._translate.use(dropdownLanguage);
			this._emittersService.languajeEmiter.emit();
			this._storageService.removeStorage('dropdown-language');
			this.setLanguageByUser({
				language: dropdownLanguage,
				status: true
			}).subscribe();
		} else {
			this.loadingUserId = userId;
			this.getLanguageByUser().subscribe({
				next: (res) => {
					this.loadingUserId = '';
					this.loadedUserId = userId;
					this.first = true;
					this._translate.use(res.language);
					setTimeout(() => {
						this._emittersService.languajeEmiter.emit();
					}, 200);
				},
				error: () => (this.loadingUserId = '')
			});
		}
	}

	// GET METHODS
	getLanguageByUser(): Observable<Language> {
		const URL = `${BASE_URL}/${servicesConfig.languageHandling.routes.user}/${this._authService.currentUser.user.sub}`;
		return this._http.get<Language>(URL);
	}
	// END GET METHODS

	// PUT METHODS
	setLanguageByUser(body: any): Observable<Language> {
		const URL = `${BASE_URL}/${servicesConfig.languageHandling.routes.user}/${this._authService.currentUser.user.sub}`;
		return this._http.put<Language>(URL, body);
	}
	// END PUT METHODS
}
